'use client';
import dynamic from 'next/dynamic';

import { useDevice } from '@contexts/device';

import { SideBarType } from './hooks';
import { Container, Wrapper } from './styled';

const StaticPageDesktop = dynamic(() => import('./pages/StaticPageDesktop'));
const StaticPageMobile = dynamic(() => import('./pages/StaticPageMobile'));

const StaticPages = ({ type }: { type: SideBarType }) => {
  const { isDesktop } = useDevice();
  return (
    <Container>
      <Wrapper>
        {isDesktop ? (
          <StaticPageDesktop type={type} />
        ) : (
          <StaticPageMobile type={type} />
        )}
      </Wrapper>
    </Container>
  );
};

export default StaticPages;
